import { Injectable, TransferState, inject } from "@angular/core";
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TServiceResult } from '@shared/helper/t-service-result';
import { BookGenreModel, BookGenreSettingModel, setBookGenreModel } from '@app/pages/genres/model/book-genre-model';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { ServiceResult } from '@shared/helper/service-result';
import { HttpBaseService } from '../base_services/http_base.service';
import { TermFilterModel } from "@shared/model/categoryAndSearch/term-filter-model";




@Injectable({
    providedIn: "root"
})
export class BookGenresService extends HttpBaseService {
    private serverState = inject(TransferState);

    constructor() {
        const repo = inject(LocalRepository);
        const http = inject(HttpClient);

        super(repo, http, 'bgen');
    }

    getBookGenreById(id: string): Observable<TServiceResult<BookGenreModel>> {
        return this.http.get<TServiceResult<BookGenreModel>>(`${this.apiUrl}/Get/${id} `);
    }

    getAllBookGenres(): Observable<TServiceResult<PageList<BookGenreModel>>> {
        return this.http.get<TServiceResult<PageList<BookGenreModel>>>(`${this.apiUrl}/GetAll`);
    }

    createNewBookGenre(genre: BookGenreModel): Observable<TServiceResult<BookGenreModel>> {
        return this.http.post<TServiceResult<BookGenreModel>>(`${this.apiUrl}/Create`, genre);
    }

    updateBookGenre(genres: setBookGenreModel): Observable<ServiceResult> {
        return this.http.post<ServiceResult>(`${this.apiUrl}/SetWorkGenres`, genres);
    }

    deleteBookGenre(id: string): Observable<TServiceResult<BookGenreModel>> {
        return this.http.delete<TServiceResult<BookGenreModel>>(`${this.apiUrl}/Delete/${id} `);
    }

    // ? check this type whit MH
    getCountByTitle(title: string): Observable<TServiceResult<ServiceResult>> {
        return this.http.delete<TServiceResult<ServiceResult>>(` ${this.apiUrl}/GetCountByTitle/${title} `);
    }

    getByBookId(bookId: string, TF?: TermFilterModel): Observable<TServiceResult<PageList<BookGenreSettingModel>>> {
        let paramsValues = '';
        if (TF?.pgNumber || TF?.pgNumber == 0)
            paramsValues = `?PgNumber=${TF?.pgNumber}`
        if (TF?.pgSize)
            paramsValues = `?PgSize=${TF?.pgSize}`
        if ((TF?.pgNumber || TF?.pgNumber == 0) && TF?.pgSize)
            paramsValues = `?PgNumber=${TF?.pgNumber}&PgSize=${TF?.pgSize}`
        return this.http.get<TServiceResult<PageList<BookGenreSettingModel>>>(`${this.apiUrl}/GetByBookId/${bookId}/${paramsValues}`)
    }

    getAllByWorkId(workId?: string): Observable<TServiceResult<PageList<BookGenreSettingModel>>> {
        return this.http.get<TServiceResult<PageList<BookGenreSettingModel>>>(`${this.apiUrl}/GetAllByWorkId/${workId}`);
    }
}
